// NOTE: derived from https://github.com/mapbox/seidel/
import { Edge, isDefined, Point, TrapezoidalMap, triangulateMountain } from "./internal";
export function triangulate(rings) {
    const triangles = [];
    const edges = [];
    let i;
    let j;
    let k;
    let points;
    let p;
    let q;
    let len;
    let done;
    for (k = 0; k < rings.length; k++) {
        points = rings[k];
        let index = 0;
        // build a set of edges from points
        for (i = 0, len = points.length; i < len; i++) {
            if (!isDefined(points[i][2]))
                points[i][2] = index;
            j = i < len - 1 ? i + 1 : 0;
            if (!isDefined(points[j][2]))
                points[j][2] = index + 1;
            p = i ? q : shearTransform(points[i]);
            q = shearTransform(points[j]);
            if (p.x != q.x) {
                edges.push(p.x > q.x ? new Edge(q, p) : new Edge(p, q));
            }
            index++;
        }
    }
    const map = new TrapezoidalMap();
    for (i = 0; i < edges.length; i++) {
        done = map.addEdge(edges[i]);
        if (!done)
            return null;
    }
    done = map.collectPoints();
    if (!done)
        return null;
    // Generate the triangles
    for (i = 0; i < edges.length; i++) {
        if (edges[i].poly && edges[i].poly.length)
            triangulateMountain(edges[i], triangles);
    }
    return triangles.length ? triangles : null;
}
// Shear transform. May effect numerical robustness
const SHEAR = 1e-10;
export function shearTransform(point) {
    return new Point(point[0] + SHEAR * point[1], point[1], point[2]);
}
//# sourceMappingURL=seidel.js.map